export type LearningMaterialSkillSlug =
	| "lesson"
	| "quiz"
	| "flashcards"
	| "practice"
	| "study-guide";

export type LearningMaterialSkill = {
	slug: LearningMaterialSkillSlug;
	name: string;
	description: string;
	agentInstruction: string;
};

export const LEARNING_MATERIAL_SKILLS = [
	{
		slug: "lesson",
		name: "Lesson",
		description: "Generate an interactive lesson with explanations, examples, and checks.",
		agentInstruction:
			"Generate an interactive lesson with a clear concept arc, concise explanation, examples, and lightweight comprehension checks.",
	},
	{
		slug: "quiz",
		name: "Quiz",
		description: "Generate assessment-style questions with plausible distractors.",
		agentInstruction:
			"Generate assessment-style questions with plausible distractors, answer validation, and explanations that teach from mistakes.",
	},
	{
		slug: "flashcards",
		name: "Flashcards",
		description: "Generate memorization cards from terms, definitions, or source material.",
		agentInstruction:
			"Generate memorization-focused flashcards from terms, definitions, facts, vocabulary, or the provided source material.",
	},
	{
		slug: "practice",
		name: "Practice",
		description: "Generate scaffolded worksheet-style exercises with increasing difficulty.",
		agentInstruction:
			"Generate scaffolded worksheet-style practice with progressively harder exercises and enough feedback to support independent work.",
	},
	{
		slug: "study-guide",
		name: "Study Guide",
		description:
			"Generate structured review material, key terms, misconceptions, and questions.",
		agentInstruction:
			"Generate a structured study guide with key ideas, terms, misconceptions, summaries, and review questions.",
	},
] as const satisfies readonly LearningMaterialSkill[];

export function formatLearningMaterialSkillsForPrompt() {
	return LEARNING_MATERIAL_SKILLS.map(
		(skill) => `- /${skill.slug} (${skill.name}): ${skill.agentInstruction}`,
	).join("\n");
}
